import React from 'react';

import NespressoLogo from '../../assets/images/sponsors/nespresso-logo.png';
import RedbullLogo from '../../assets/images/sponsors/redbull-logo.png';
import SofiaSupporterLogo from '../../assets/images/sponsors/SofiaSupporterLogo.png';
import SofiaRecursiveLogo from '../../assets/images/sponsors/The_Recursive_Final_logo-without_slogan-05.png';
import OReillyLogo from '../../assets/images/sponsors/OReilly_logo_white_rgb.png';

const SupportersLogoContainer = () => {
    return (
        <div className="flex justify-center items-center flex-wrap gap-10 xs:gap-16 px-8 md:px-24 xl:px-48 mt-24">
            {/* TODO: clarify with Prague Team if we have the permissions to publish Nespresso and Red Bull logo in collabothon.eu */}
            {/* 
            <img
                src={NespressoLogo}
                alt={`Nespresso Logo`}
                className="h-16 md:h-24 object-scale-down"
            />
            <img
                src={RedbullLogo}
                alt={`RedBull Logo`}
                className="h-16 md:h-24 object-scale-down"
            /> 
            */}
            <img
                src={OReillyLogo}
                alt={`Logo of supporting company`}
                className="h-8 md:h-22 object-scale-down"
            />
            <img
                src={SofiaSupporterLogo}
                alt={`Logo of supporting company`}
                className="h-24 md:h-24 object-scale-down"
            />
            <img
                src={SofiaRecursiveLogo}
                alt={`Logo of supporting company`}
                className="h-32 md:h-48 object-scale-down"
            />
        </div>
    );
};

export default SupportersLogoContainer;
